<div class="flex flex-col gap-2 p-4">
  <div class="text-[10px] font-semibold uppercase tracking-wider text-neutral-400">Bounding Box</div>
  <div class="grid grid-cols-2 gap-1.5">
    <dojo-number-input label="x Start" [formCtrl]="xStartCtrl" [step]="1" [size]="'s'" />
    <dojo-number-input label="x End" [formCtrl]="xEndCtrl" [step]="1" [size]="'s'" />
    <dojo-number-input label="y Start" [formCtrl]="yStartCtrl" [step]="1" [size]="'s'" />
    <dojo-number-input label="y End" [formCtrl]="yEndCtrl" [step]="1" [size]="'s'" />
  </div>

  <dojo-single-select
    label="Fixed Axis"
    [formCtrl]="fixedAxisCtrl"
    [options]="fixedAxisOptions"
    optionLabel="label"
    optionValue="value"
    [size]="'s'"
    (selectionChange)="onFixedAxisChange($event)"
  />

  <mat-slide-toggle [checked]="gridVisible()" (change)="onGridVisibleChange($event.checked)">Grid</mat-slide-toggle>
  @if (gridVisible()) {
    <dojo-single-select
      label="Type"
      [formCtrl]="gridTypeCtrl"
      [options]="gridTypeOptions"
      optionLabel="label"
      optionValue="value"
      [size]="'s'"
      (selectionChange)="onGridTypeChange($event)"
    />
  }

  <dojo-single-select
    label="Axes"
    [formCtrl]="axesModeCtrl"
    [options]="axesModeOptions"
    optionLabel="label"
    optionValue="value"
    [size]="'s'"
    (selectionChange)="onAxesModeChange($event)"
  />

  @if (axesMode() === 'custom') {
    <div class="flex flex-col gap-2 border-l-2 border-neutral-100 pl-3">
      @for (axis of axesArray(); track axis.id; let idx = $index) {
        <div class="flex flex-col gap-1.5 rounded border border-neutral-100 p-2">
          <div class="flex items-center justify-between">
            <span class="text-xs font-medium">{{ axis.id }}</span>
            <dojo-icon-button icon="trash" [size]="'xs'" (click)="onDeleteAxis(idx)" />
          </div>
          <div class="grid grid-cols-2 gap-1.5">
            <dojo-single-select
              label="Orientation"
              [formCtrl]="getAxisCtrl(idx, 'orientation')"
              [options]="axisOrientationOptions"
              optionLabel="label"
              optionValue="value"
              [size]="'s'"
              (selectionChange)="onAxisFieldChange(idx, 'orientation', $event)"
            />
            <dojo-number-input
              label="Position"
              [formCtrl]="getAxisNumberCtrl(idx, 'position')"
              [step]="1"
              [size]="'s'"
            />
          </div>
          <mat-slide-toggle
            [checked]="axis.isPrimary === true"
            (change)="onAxisFieldChange(idx, 'isPrimary', $event.checked)"
            >Primary</mat-slide-toggle
          >
          <div class="mt-1 text-[10px] font-semibold uppercase tracking-wider text-neutral-400">Ticks</div>
          <div class="grid grid-cols-2 gap-1.5">
            <dojo-number-input
              label="Distance"
              [formCtrl]="getAxisNumberCtrl(idx, 'ticks.ticksDistance')"
              [step]="0.5"
              [min]="0.1"
              [size]="'s'"
            />
            <dojo-single-select
              label="Format"
              [formCtrl]="getAxisCtrl(idx, 'ticks.labelFormat')"
              [options]="labelFormatOptions"
              optionLabel="label"
              optionValue="value"
              [size]="'s'"
              (selectionChange)="onAxisTicksFieldChange(idx, 'labelFormat', $event)"
            />
          </div>
          <div class="mt-1 text-[10px] font-semibold uppercase tracking-wider text-neutral-400">Label</div>
          <dojo-text-input label="Text" [formCtrl]="getAxisTextCtrl(idx, 'axisLabel.text')" [size]="'s'" />
          <dojo-number-input
            label="Font Size"
            [formCtrl]="getAxisNumberCtrl(idx, 'axisLabel.fontSize')"
            [step]="1"
            [min]="6"
            [max]="24"
            [size]="'s'"
          />
        </div>
      }
      <button
        class="flex items-center gap-1 rounded px-1.5 py-1 text-[11px] text-neutral-400 hover:bg-neutral-50 hover:text-neutral-600"
        (click)="onAddAxis()"
      >
        <dojo-icon icon="plus" [size]="10" /> Add Axis
      </button>
    </div>
  }

  <div class="mt-1 flex items-center justify-between border-t border-neutral-100 pt-2">
    <span class="text-[10px] font-semibold uppercase tracking-wider text-neutral-400">Ticks</span>
    <mat-slide-toggle [checked]="ticksVisible()" (change)="onTicksVisibleChange($event.checked)" />
  </div>
  @if (ticksVisible()) {
    <div class="flex flex-col gap-1.5 border-l-2 border-neutral-100 pl-3">
      <div class="grid grid-cols-2 gap-1.5">
        <dojo-number-input label="Distance" [formCtrl]="ticksDistanceCtrl" [step]="0.5" [min]="0.1" [size]="'s'" />
        <dojo-number-input
          label="Minor Ticks"
          [formCtrl]="minorTicksCtrl"
          [step]="1"
          [min]="0"
          [max]="10"
          [size]="'s'"
        />
      </div>
      <div class="flex items-center gap-3">
        <mat-slide-toggle [checked]="drawLabelsCtrl.value" (change)="onDrawLabelsChange($event.checked)"
          >Draw Labels</mat-slide-toggle
        >
        <mat-slide-toggle [checked]="drawZeroCtrl.value" (change)="onDrawZeroChange($event.checked)"
          >Draw Zero</mat-slide-toggle
        >
      </div>
      <dojo-single-select
        label="Label Format"
        [formCtrl]="labelFormatCtrl"
        [options]="labelFormatOptions"
        optionLabel="label"
        optionValue="value"
        [size]="'s'"
        (selectionChange)="onLabelFormatChange($event)"
      />
    </div>
  }
</div>
